import { createFileRoute } from "@tanstack/react-router";
import BulkImport from "@/pages/BulkImport";
import { PrivateRoute } from "@/components/shared/PrivateRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/bulk-import/")({
  head: () => routeHead("/de/bulk-import/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateRoute><BulkImport /></PrivateRoute>
  );
}
